import trainersService from '../../api/trainers'
import { merge } from 'ramda'

const state = {
  all: [],
  trainer: null,
  totalPages: 0,
  currentPage: 0,
  error: ''
}

const getters = {
  trainer (state) {
    return state.trainer
  },
  allTrainers (state) {
    return state.all
  },
  totalPages (state) {
    return state.totalPages
  }
}

const actions = {
  async getAllTrainers ({ commit }, page) {
    commit('loading/toggleActive', null, { root: true })
    const trainersResponse = await trainersService.getAll(page)
    const trainers = trainersResponse.content

    commit('setTrainers', trainers)
    commit('setTotalPages', trainersResponse.totalPages)
    commit('setCurrentPage', page)
    commit('loading/toggleActive', null, { root: true })
  },
  async getTrainer ({ commit }, id) {
    commit('loading/toggleActive', null, { root: true })
    const trainerResponse = await trainersService.get(id)

    commit('setTrainer', trainerResponse)
    commit('loading/toggleActive', null, { root: true })
  },
  async removeTrainer ({ commit, state }, id) {
    commit('loading/toggleActive', null, { root: true })
    commit('setError', '')

    const isRemoved = await trainersService.remove(id)

    if (isRemoved) {
      const trainersResponse = await trainersService.getAll(state.currentPage)
      const trainers = trainersResponse.content

      commit('setTrainers', trainers)
      commit('setTotalPages', trainersResponse.totalPages)

      commit('loading/toggleActive', null, { root: true })

      return true
    }

    commit('setError', 'Something wrong while trying to delete the trainer')
    commit('loading/toggleActive', null, { root: true })
  },
  async addTrainer ({ commit, state }, data) {
    commit('loading/toggleActive', null, { root: true })

    const isAdded = await trainersService.create(data)

    commit('loading/toggleActive', null, { root: true })

    if (isAdded) {
      return true
    }

    return false
  },
  async updateTrainer ({ commit, state }, data) {
    commit('loading/toggleActive', null, { root: true })

    let dataUpdateTrainer = merge(state.trainer, data)
    dataUpdateTrainer.user = merge(state.trainer.user, data.user)

    const isUpdated = await trainersService.update(dataUpdateTrainer)

    commit('loading/toggleActive', null, { root: true })

    if (isUpdated) {
      return true
    }

    return false
  },
  async updateTrainerPassword ({ commit, state }, data) {
    commit('loading/toggleActive', null, { root: true })

    const isUpdated = await trainersService.updatePassword(data)

    commit('loading/toggleActive', null, { root: true })

    if (isUpdated) {
      return true
    }

    return false
  },
  clearTrainer ({ commit }) {
    commit('setTrainer', null)
  },
  clearAllTrainers ({ commit }) {
    commit('setTrainers', [])
  }
}

const mutations = {
  setTrainers (state, trainers) {
    state.all = trainers
  },
  setTrainer (state, trainer) {
    state.trainer = trainer
  },
  setTotalPages (state, totalPages) {
    state.totalPages = totalPages
  },
  setCurrentPage (state, currentPage) {
    state.currentPage = currentPage
  },
  setError (state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/trainers.js